import React from "react";
import PageShell from "@/components/PageShell";

const SECTIONS = [
    {
        title: "What We Collect",
        body: [
            "Information you give us: name, email, shipping/billing address, and (where relevant) phone number when you place an order or sign up to the drop list.",
            "Information collected automatically: device type, browser, IP address, pages visited, referring URL. We use this to understand site performance and to protect against fraud.",
            "Information from payment partners: Square processes your card data directly. We never see or store your full card number — we only receive transaction details such as a payment ID and limited card metadata.",
        ],
    },
    {
        title: "How We Use It",
        body: [
            "To process and ship your orders, send order confirmations, and handle returns.",
            "To notify you of new drops if you've opted into the newsletter (you can unsubscribe anytime via the link in any email).",
            "To improve the site, prevent fraud, and meet legal obligations (tax records, etc.).",
            "We will never sell your personal data. Ever.",
        ],
    },
    {
        title: "Who We Share It With",
        body: [
            "Shipping carriers (DHL, Royal Mail, UPS) — only the data they need to deliver your order.",
            "Square — to process payment.",
            "Email service provider — for transactional and marketing email delivery.",
            "Legal authorities, if compelled by a valid legal request.",
        ],
    },
    {
        title: "Your Rights",
        body: [
            "Access — request a copy of the data we hold on you.",
            "Correction — fix anything that's wrong.",
            "Deletion — ask us to delete your data (subject to legal retention requirements for orders/tax).",
            "Portability — get your data in a machine-readable format.",
            "Withdraw consent — opt out of marketing at any time.",
            "To exercise any of these rights, email privacy@uknitwear.com. We respond within 30 days.",
        ],
    },
    {
        title: "Data Retention",
        body: [
            "Order records: 7 years (UK/EU tax law).",
            "Marketing subscribers: until you unsubscribe.",
            "Site analytics: 26 months (anonymised after).",
        ],
    },
    {
        title: "International Transfers",
        body: [
            "Our servers are based in the EU. If we transfer data outside the EU/UK, we use Standard Contractual Clauses and only work with partners certified under recognised data protection frameworks.",
        ],
    },
    {
        title: "Contact",
        body: [
            "Questions, concerns, or requests: privacy@uknitwear.com",
            "UK / EU users: you have the right to lodge a complaint with the ICO (UK) or your local DPA.",
        ],
    },
];

const Privacy = () => {
    return (
        <PageShell
            kicker="[Legal / Last Updated 01.02.2026]"
            title="Privacy"
            accent="Policy."
            intro="Plain language. No tricks. Here's exactly what we collect, why, and what you can do about it."
            testid="privacy-page"
        >
            <section className="px-4 md:px-8 py-10 border-b-4 border-ink">
                <div className="max-w-3xl space-y-10">
                    {SECTIONS.map((s, i) => (
                        <article key={s.title} data-testid={`privacy-section-${i}`}>
                            <div className="flex items-baseline gap-3">
                                <span className="font-mono-ui text-xs uppercase tracking-[0.25em] text-hazard">
                                    // 0{i + 1}
                                </span>
                                <h2 className="font-heading text-3xl md:text-4xl uppercase leading-none">
                                    {s.title}
                                </h2>
                            </div>
                            <ul className="mt-4 space-y-2 list-disc list-outside ml-5 text-sm md:text-base text-foreground/80 leading-relaxed">
                                {s.body.map((b, j) => (
                                    <li key={j}>{b}</li>
                                ))}
                            </ul>
                        </article>
                    ))}
                </div>
            </section>
        </PageShell>
    );
};

export default Privacy;
